import SendDocumentModal from './SendDocumentModal'

export default SendDocumentModal
